// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldMatchExpression } from './FieldMatchExpression';
import {
  FieldMatchExpressionFromJSON,
  FieldMatchExpressionFromJSONTyped,
  FieldMatchExpressionToJSON,
  FieldMatchExpressionToJSONTyped,
} from './FieldMatchExpression';

/**
 *
 * @export
 * @interface FieldExpression
 */
export interface FieldExpression {
  /**
   *
   * @type {Array<FieldMatchExpression>}
   * @memberof FieldExpression
   */
  match?: Array<FieldMatchExpression>;
}

/**
 * Check if a given object implements the FieldExpression interface.
 */
export function instanceOfFieldExpression(
  value: object,
): value is FieldExpression {
  return true;
}

export function FieldExpressionFromJSON(json: any): FieldExpression {
  return FieldExpressionFromJSONTyped(json, false);
}

export function FieldExpressionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FieldExpression {
  if (json == null) {
    return json;
  }
  return {
    match:
      json['match'] == null
        ? undefined
        : (json['match'] as Array<any>).map(FieldMatchExpressionFromJSON),
  };
}

export function FieldExpressionToJSON(json: any): FieldExpression {
  return FieldExpressionToJSONTyped(json, false);
}

export function FieldExpressionToJSONTyped(
  value?: FieldExpression | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    match:
      value['match'] == null
        ? undefined
        : (value['match'] as Array<any>).map(FieldMatchExpressionToJSON),
  };
}
